const title = 'Pro - ';

/* start flow */
export const TRACK_PRO_BUTTON_CLICKED = `${title} Go Pro Button clicked`;
export const TRACK_PRO_CHECKOUT_STARTED = `${title} Checkout opened`;
export const TRACK_PRO_ONBOARD_VIDEO = `${title} Onboarding video clicked`;
export const TRACK_PRO_MANAGE_OPENED = `${title} Manage subscription opened`;

/* in flow */
export const TRACK_PRO_SUB_STARTED = `${title} Subscription started`;
export const TRACK_PRO_SUB_CANCELLED = `${title} Subscription cancelled`;
export const TRACK_PRO_SUB_CANCELLED_REASON = `${title} Subscription cancellation reason`;
export const TRACK_PRO_SUB_CHANGED_MIND = `${title} Subscription cancelled changed mind`;
export const TRACK_PRO_TRIAL_STARTED = `${title} Trial started`;
export const TRACK_PRO_TRIAL_ENDED = `${title} Trial ended`;
export const TRACK_PRO_PAYMENT_SELECT = `${title} Payment selection`;
export const TRACK_PRO_PAYMENT_NEW = `${title} New payment method`;
export const TRACK_PRO_SUB_REACTIVATE = `${title} Subscription reactivated`;
export const TRACK_PRO_SUB_PAID = `${title} Subscription payment succesful`;

/* end flow */
export const TRACK_PRO_CHECKOUT_CLOSED = `${title} Checkout closed`;
export const TRACK_PRO_MANAGE_CLOSED = `${title} Manage subscription closed`;

export const proTracking = {
  TRACK_PRO_BUTTON_CLICKED,
  TRACK_PRO_CHECKOUT_STARTED,
  TRACK_PRO_ONBOARD_VIDEO,
  TRACK_PRO_MANAGE_OPENED,
  TRACK_PRO_SUB_STARTED,
  TRACK_PRO_SUB_CANCELLED,
  TRACK_PRO_SUB_CANCELLED_REASON,
  TRACK_PRO_SUB_CHANGED_MIND,
  TRACK_PRO_TRIAL_STARTED,
  TRACK_PRO_TRIAL_ENDED,
  TRACK_PRO_PAYMENT_SELECT,
  TRACK_PRO_PAYMENT_NEW,
  TRACK_PRO_SUB_REACTIVATE,
  TRACK_PRO_SUB_PAID,
  TRACK_PRO_CHECKOUT_CLOSED,
  TRACK_PRO_MANAGE_CLOSED
};
